module.exports = __webpack_public_path__ + "static/media/er.53cad92e.svg";